import { Button } from '@mui/material';
import { Star } from 'lucide-react';

import { useLocale } from '@shared/hooks/locale';

const ReviewCtaButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  const { t } = useLocale();
  return (
    <Button
      variant="soft"
      fullWidth
      startIcon={<Star />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('Get reviews')}
    </Button>
  );
};

export default ReviewCtaButton;
